import React from 'react';

import { Link } from '@mui/material';

function GfmLink() {
  return (
    <Link
      color="inherit"
      underline="hover"
      fontWeight="fontWeightMedium"
      target="_blank"
      href="https://docs.github.com/en/get-started/writing-on-github/getting-started-with-writing-and-formatting-on-github/basic-writing-and-formatting-syntax"
    >
      GitHub Flavored Markdown
    </Link>
  );
}

function LiquidLink() {
  return (
    <Link
      color="inherit"
      underline="hover"
      fontWeight="fontWeightMedium"
      target="_blank"
      href="https://liquidjs.com/tutorials/intro-to-liquid.html"
    >
      Liquid templating
    </Link>
  );
}

export function GfmLiquidHelperText() {
  return (
    <>
      <GfmLink />
      {' and '}
      <LiquidLink />
      {' supported'}.
    </>
  );
}

export function LiquidHelperText() {
  return (
    <>
      HTML and <LiquidLink />
      {' supported'}.
    </>
  );
}
